export default "__VITE_ASSET__DYObOWfP__"